function defaultConfirmMessage() {
  if (typeof document === 'undefined' || !document.body) return 'Are you sure?';
  return document.body.dataset.i18nDeleteConfirm || 'Are you sure?';
}

export default function confirmAction(messageOrCallback, onConfirmOrOpts, maybeOpts) {
  // Support confirmAction(onConfirm) — uses default i18n message
  let message;
  let onConfirm;
  let opts;
  if (typeof messageOrCallback === 'function') {
    message = defaultConfirmMessage();
    onConfirm = messageOrCallback;
    opts = onConfirmOrOpts || {};
  } else {
    message = messageOrCallback || defaultConfirmMessage();
    onConfirm = onConfirmOrOpts;
    opts = maybeOpts || {};
  }

  const variant = opts.variant || 'danger';
  if (typeof window !== 'undefined' && window.TeamforceNotifications && typeof window.TeamforceNotifications.confirm === 'function') {
    window.TeamforceNotifications.confirm({
      message,
      variant,
      onConfirm,
      onCancel: opts.onCancel,
    });
    return;
  }

  if (typeof window !== 'undefined' && window.confirm(message)) {
    onConfirm();
  } else if (opts.onCancel) {
    opts.onCancel();
  }
}
